<div class="new-password-flow" (input)="onFieldInteraction($event)" (pointerdown)="onFieldInteraction($event)">
    <div class="new-password-flow__backdrop" aria-hidden="true"></div>

    <div class="new-password-flow__row">
        <div class="new-password-flow__card">
            <img class="new-password-flow__logo" src="./assets/images/logos/login-logo.png" alt="COMMITLY"/>

            <form #accountForm class="new-password-flow__form" [formGroup]="formGroup" (ngSubmit)="createPassword()">
                <button type="submit" hidden tabindex="-1" aria-hidden="true"></button>
                <p class="new-password-flow__heading">
                    {{headingKey | translate}}
                </p>

                <ng-container *ngIf="showPasswordForm">
                    <input
                        *ngIf="email"
                        class="new-password-flow__username"
                        type="email"
                        name="username"
                        id="username"
                        autocomplete="username"
                        tabindex="-1"
                        aria-hidden="true"
                        [formControl]="emailCtrl"
                        data-test-id="new-password-email"
                    />

                    <div class="new-password-flow__field">
                        <app-input-password
                            appAutofocus
                            data-test-id="new-password-input"
                            [name]="'new-password'"
                            [id]="'new-password'"
                            [autocomplete]="'new-password'"
                            [control]="newPassword"
                            [tabindex]="2"
                            [labelName]="'NewPassword.Form.PasswordLabel' | translate"
                            [placeholder]="'NewPassword.Form.PasswordPlaceholder' | translate"
                            [submitted]="submitPressed"
                        ></app-input-password>

                        <span class="new-password-flow__error" *ngIf="submitPressed && newPassword.errors">
                            {{'NewPassword.Form.ErrorPasswordsFormat' | translate}}
                        </span>

                        <div class="new-password-flow__error-summary" data-test-id="new-password-error" *ngIf="errorMessage">
                            <span class="new-password-flow__error">{{errorMessage | translate}}</span>
                        </div>
                    </div>

                    <ui-text-button [tabindex]="6" class="new-password-flow__submit" [buttonStyle]="buttonStyle.Green"
                                    data-test-id="new-password-submit"
                                    (click)="accountForm.requestSubmit()"
                                    [disabled]="isSubmitting">
                        {{((screen.kind === 'activate' ? 'NewPassword.Form.ActivateSubmit' : 'NewPassword.Form.Submit')) | translate}}
                    </ui-text-button>

                    <div class="new-password-flow__trust">
                        <div class="new-password-flow__divider"></div>
                        <p class="new-password-flow__note">{{'SignUp.Step.Step3Footer' | translate}}</p>
                        <ul class="new-password-flow__badges">
                            <li><img src="./assets/images/certificate1.webp" alt="ISO/IEC 27001:2022 certified"/></li>
                            <li><img src="./assets/images/certificate2.webp" alt="DSGVO / GDPR"/></li>
                            <li><img src="./assets/images/certificate3.webp" alt="EU AI Act ready, 100% opt-in"/></li>
                            <li><img src="./assets/images/certificate4.webp" alt="Made in Europe, hosted in Germany"/></li>
                        </ul>
                    </div>
                </ng-container>

                <div class="new-password-flow__notice" data-test-id="new-password-notice" *ngIf="successMessage">
                    {{successMessage | translate}}
                </div>

                <div class="new-password-flow__link-row" *ngIf="screen.kind === 'activate' && screen.status === 'invalid'">
                    <p *ngIf="resent">{{'NewPassword.ResendSent' | translate}}</p>
                    <p *ngIf="!resent">{{'NewPassword.InvalidLink' | translate}}</p>
                    <div class="new-password-flow__error-summary" data-test-id="new-password-error" *ngIf="errorMessage">
                        <span class="new-password-flow__error">{{errorMessage | translate}}</span>
                    </div>
                    <ui-text-button *ngIf="!resent"
                                    class="new-password-flow__submit"
                                    [buttonStyle]="buttonStyle.Green"
                                    data-test-id="new-password-resend"
                                    (click)="resend()"
                                    [disabled]="isSubmitting">
                        {{'NewPassword.Resend' | translate}}
                    </ui-text-button>
                </div>

                <div class="new-password-flow__link-row" *ngIf="screen.kind === 'activate' && screen.status === 'active'">
                    <p>{{'NewPassword.AlreadyActive' | translate}}</p>
                    <a [uiSref]="signInState">{{'NewPassword.SignIn' | translate}}</a>
                </div>
            </form>
        </div>

    </div>
</div>
